import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "degree/";

//  学位外语  - 分页
export const degreePage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "examInfo", {
           data: _params,
           method: "GET",
         });
       };

//  学位外语  - 获取考试关联的考点信息
export const degreeSitePage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "sitePage", {
           data: _params,
           method: "GET",
         });
       };

//  学位外语  - 报考
export const degreeRegisterExam = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "registerExam", {
           data: _params,
           method: "POST",
         });
       };

//  学位外语  - 获取学位外语报考相关信息
export const degreeCandidateInfo = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "candidateInfo", {
           data: _params,
           method: "GET",
         });
       };
//  学位外语  - 获取学位课程列表
export const degreeCourseList = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "courseList", {
           data: _params,
           method: "GET",
         });
       };

//  学位外语  - 缴费
export const degreePay = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "pay", {
           data: Qs.stringify(_params),
           method: "POST",
         });
       };

// 学位外语 - 上传
export const degreeUploadPhoto = (params) => {
         return sendRequest(api.url + _base + "uploadPhoto", {
           data: params,
           method: "POST",
         });
       };
//  学位外语  - 获取学位外语申请免考详情
export const applyExemptInfo = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "applyExemptInfo", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};
//  学位外语  - 学位外语申请免考
export const applyExempt = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "applyExempt", {
    data: _params,
    method: "POST",
  });
};

//  学位外语  - 编辑学位外语免考申请
export const editApplyExempt = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "editApplyExempt", {
    data: _params,
    method: "POST",
  });
};

//  学位外语  - 删除学位外语申请免考(只有待审核状态才能申请)
export const delApplyExempt = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "delApplyExempt", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};

//  学位外语  - 学位外语成绩
//  后端: GET /degree/score → 返回 List<StudentDegreeCourseScoreVO>{courseName, studyResult, studyResultName, passTime}
export const degreeScore = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "score", {
    data: _params,
    method: "GET",
  });
};

//  学位外语  - 下载准考证
//  后端: GET /degree/downloadCertificate?examCandidateId= → 返回 PDF 路径
export const downloadCertificate = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "downloadCertificate", {
    data: _params,
    method: "GET",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/degree.js